import { Link } from "react-router-dom";

/** One headline figure on the Dashboard. `attention` marks a count that needs someone to act (brand-coloured edge).
 *  With `to` it links to a page; with `onClick` it is a button (it opens a pop-up). */
export function StatTile({
  label,
  value,
  to,
  onClick,
  attention = false,
}: {
  label: string;
  value: number;
  to?: string;
  onClick?: () => void;
  attention?: boolean;
}) {
  const className = `rc-card rc-stat${attention ? " rc-stat-attn" : ""}`;
  const body = (
    <>
      <div className="rc-stat-value">{value}</div>
      <div className="rc-stat-label">{label}</div>
    </>
  );
  if (to) {
    return (
      <Link to={to} className={className}>
        {body}
      </Link>
    );
  }
  if (onClick) {
    return (
      <button type="button" onClick={onClick} className={className} style={{ textAlign: "left", font: "inherit", cursor: "pointer" }}>
        {body}
      </button>
    );
  }
  return <div className={className}>{body}</div>;
}
